import { z } from 'zod';

export const ruleSchema = z
  .object({
    name: z.string().trim().min(1, 'Name is required').max(255),
    source_calendar_id: z
      .number({ invalid_type_error: 'Pick a source calendar' })
      .int()
      .positive('Pick a source calendar'),
    target_calendar_id: z
      .number({ invalid_type_error: 'Pick a target calendar' })
      .int()
      .positive('Pick a target calendar'),
    replacement_title: z
      .string()
      .trim()
      .min(1, 'Replacement title is required')
      .max(255),
    allow_downstream_overrides: z.boolean(),
    min_duration_minutes: z
      .number({ invalid_type_error: 'Must be a number' })
      .int()
      .min(0, 'Must be ≥ 0'),
    detection_mode: z.enum(['webhook', 'poll']),
    poll_interval_s: z
      .number({ invalid_type_error: 'Must be a number' })
      .int()
      .positive('Must be greater than 0'),
  })
  .refine((v) => v.source_calendar_id !== v.target_calendar_id, {
    path: ['target_calendar_id'],
    message: 'Source and target must be different calendars',
  });

export type RuleFormValues = z.infer<typeof ruleSchema>;

export const ruleDefaults: RuleFormValues = {
  name: '',
  source_calendar_id: 0,
  target_calendar_id: 0,
  replacement_title: 'Busy',
  allow_downstream_overrides: false,
  min_duration_minutes: 5,
  detection_mode: 'webhook',
  poll_interval_s: 300,
};
